import React from 'react';
import { Radio } from 'antd';
import { CustomComponentProps, FieldOption } from '../types';

/**
 * Custom Radio wrapper component
 */
export interface MyRadioProps extends CustomComponentProps {
  options?: FieldOption[];
  buttonStyle?: 'outline' | 'solid';
  optionType?: 'default' | 'button';
}

const MyRadio: React.FC<MyRadioProps> = ({
  value,
  onChange,
  disabled,
  readonly,
  options = [],
  buttonStyle = 'outline',
  optionType = 'default',
  ...rest
}) => {
  const handleChange = (e: any) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Radio.Group
      value={value}
      onChange={handleChange}
      disabled={disabled || readonly}
      buttonStyle={buttonStyle}
      optionType={optionType}
      options={options}
      {...rest}
    />
  );
};

export default MyRadio;
